module.exports = __webpack_public_path__ + "static/media/5 Things Financial Literacy.5d9dfb97.pdf";